// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebarOption{
    align-items: center;
    cursor: pointer;
    margin-bottom: 0px !important;
}

.sidebarOption>.sidebarbuttons:hover{
background-color:white;
border-radius: 30px;
color: #50b7f5;
transition: color 100ms ease-out;
border: none;
}


.sidebarOption>.sidebarbuttons{
border-radius: 15px;
font-weight: 500;
font-size: 1.0625rem;
margin-right: 20px;
border: none;
outline: none;
}

.sidebarOption--active>.sidebarbuttons{
color: #4795DE;
font-weight: bold;
border: none;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/settings/sidebaroptions.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,eAAe;IACf,6BAA6B;AACjC;;AAEA;AACA,sBAAsB;AACtB,mBAAmB;AACnB,cAAc;AACd,gCAAgC;AAChC,YAAY;AACZ;;;AAGA;AACA,mBAAmB;AACnB,gBAAgB;AAChB,oBAAoB;AACpB,kBAAkB;AAClB,YAAY;AACZ,aAAa;AACb;;AAEA;AACA,cAAc;AACd,iBAAiB;AACjB,YAAY;AACZ","sourcesContent":[".sidebarOption{\r\n    align-items: center;\r\n    cursor: pointer;\r\n    margin-bottom: 0px !important;\r\n}\r\n\r\n.sidebarOption>.sidebarbuttons:hover{\r\nbackground-color:white;\r\nborder-radius: 30px;\r\ncolor: #50b7f5;\r\ntransition: color 100ms ease-out;\r\nborder: none;\r\n}\r\n\r\n\r\n.sidebarOption>.sidebarbuttons{\r\nborder-radius: 15px;\r\nfont-weight: 500;\r\nfont-size: 1.0625rem;\r\nmargin-right: 20px;\r\nborder: none;\r\noutline: none;\r\n}\r\n\r\n.sidebarOption--active>.sidebarbuttons{\r\ncolor: #4795DE;\r\nfont-weight: bold;\r\nborder: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
